<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info">{{$t('alerts.loading')}}...</div>
          <div v-if="deletedItem" class="alert alert-success">{{ deletedItem['name'] }} {{$t('notifications.deleted')}}</div>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link :to="{ name: 'EXSBReasonCreate' }" class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
            </b-col>
          </b-row>
          <b-card>
            <div class="card-header">
              <h4 class="card-title">{{$t('views.exsbreasons.list.title')}}</h4>
            </div>
            <div class="card-body">
              <b-row>
                <b-col>
                  <div class="table-responsive" v-if="items.length > 0">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th>name</th>
                        <th colspan="2" />
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in items" :key="item['@id']">
                        <td>
                          <router-link v-if="item" :to="{name: 'EXSBReasonShow', params: { id: item['@id'] }}">
                            {{ item['name'] }}
                          </router-link>
                        </td>
                        <td>
                          <router-link :to="{name: 'EXSBReasonShow', params: { id: item['@id'] }}">
                            <span class="fa fa-search" aria-hidden="true" />
                            <span class="sr-only">Show</span>
                          </router-link>
                        </td>
                        <td>
                          <router-link :to="{name: 'EXSBReasonUpdate', params: { id: item['@id'] }}">
                            <span class="fa fa-pencil" aria-hidden="true" />
                            <span class="sr-only">Edit</span>
                          </router-link>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <p v-else>{{ $t('views.exsbreasons.list.noReasons') }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div v-if="view">
                    <pagination
                      :view="view"
                      @getPage="getPage($event)"
                    ></pagination>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'exsbreason/del/deleted',
    error: 'exsbreason/list/error',
    items: 'exsbreason/list/items',
    isLoading: 'exsbreason/list/isLoading',
    view: 'exsbreason/list/view'
  }),

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBReasonList')
  },

  created () {
    this.getPage()
    this.channelBusinessReasons = this.$store.state.Pusher.subscribe('e_x_s_b_reasons')
    this.channelBusinessReasons.bind('e_x_s_b_reasons', data => {
      this.getPage()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_reasons')
  },

  methods: mapActions({
    getPage: 'exsbreason/list/default'
  })
}
</script>
